"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsOfService = function (_Component) {
  (0, _inherits3.default)(TermsOfService, _Component);

  function TermsOfService() {
    (0, _classCallCheck3.default)(this, TermsOfService);
    return (0, _possibleConstructorReturn3.default)(this, (TermsOfService.__proto__ || (0, _getPrototypeOf2.default)(TermsOfService)).apply(this, arguments));
  }

  (0, _createClass3.default)(TermsOfService, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_reactHelmet2.default, { title: "K\xE4ytt\xF6ehdot\xA0ja rekisteriseloste" }),
        _react2.default.createElement(
          "div",
          { className: "container" },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement(
                "h3",
                null,
                "K\xC4YTT\xD6EHDOT"
              ),
              _react2.default.createElement(
                "p",
                null,
                "P\xE4iv\xE4ys: 4.2.2022"
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xC4YTT\xC4J\xC4N ON LUETTAVA N\xC4M\xC4 K\xC4YTT\xD6EHDOT HUOLELLISESTI JA ILMAISTAVA HYV\xC4KSYV\xC4NS\xC4 MAAP\xD6RSSI OY:N VERKKOSIVUJEN K\xC4YTT\xD6EHDOT ALLA LAUSUTULLA TAVALLA ENNEN SIVUSTON K\xC4YTT\xD6\xC4 TAI SIIHEN REKISTER\xD6ITYMIST\xC4. K\xC4YTT\xC4J\xC4 EI SAA K\xC4YTT\xC4\xC4 SIVUSTOA TAI SEN TARJOAMIA PALVELUITA, MIK\xC4LI K\xC4YTT\xC4J\xC4 EI HYV\xC4KSY N\xC4IT\xC4 K\xC4YTT\xD6EHTOJA."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "1. JOHDANTO"
              ),
              _react2.default.createElement(
                "p",
                null,
                "N\xE4m\xE4 ovat Maap\xF6rssi Oy:n (\u201D",
                _react2.default.createElement(
                  "b",
                  null,
                  "Maap\xF6rssi"
                ),
                "\u201D) verkkosivujen (\u201D",
                _react2.default.createElement(
                  "b",
                  null,
                  "Sivusto"
                ),
                "\u201D) k\xE4ytt\xF6ehdot (\u201D",
                _react2.default.createElement(
                  "b",
                  null,
                  "K\xE4ytt\xE4j\xE4ehdot"
                ),
                "\u201D). N\xE4m\xE4 K\xE4ytt\xF6ehdot sitovat Sivustoa k\xE4ytt\xE4v\xE4\xE4 henkil\xF6\xE4 (K\xE4ytt\xE4j\xE4), siit\xE4 riippumatta onko K\xE4ytt\xE4j\xE4 rekister\xF6itynyt Sivustolle vai ei. K\xE4ytt\xE4j\xE4t ovat n\xE4iden K\xE4ytt\xF6ehtojen lis\xE4ksi velvoitettuja noudattamaan Sivuston Tietosuojak\xE4yt\xE4nt\xF6\xE4 ja muita Sivustolla asetettuja s\xE4\xE4nt\xF6j\xE4 (kaikkia Sivuston s\xE4\xE4nt\xF6j\xE4 yhdess\xE4 kutsutaan Sivuston S\xE4\xE4nn\xF6iksi) sek\xE4 voimassaolevaa Suomen ja EU:n lains\xE4\xE4d\xE4nt\xF6\xE4."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Sivustolla on k\xE4yt\xF6ss\xE4 eritasoisia lisenssej\xE4. Lisenssien k\xE4ytt\xF6oikeudet vaihtelevat eri lisenssien mukaisesti. Esim. perusmuotoisella rekister\xF6innill\xE4 my\xF6nnett\xE4v\xE4 ilmainen lisenssi antaa K\xE4ytt\xE4j\xE4lle ainoastaan yleiset k\xE4ytt\xF6oikeudet p\xE4\xE4st\xE4m\xE4tt\xE4 K\xE4ytt\xE4j\xE4\xE4 katsomaan Ilmoitusten tarkkoja tietoja. Maksullisen rekister\xF6innin my\xF6t\xE4 my\xF6nnett\xE4v\xE4 lisenssi laajentaa K\xE4ytt\xE4j\xE4n k\xE4ytt\xF6oikeuksia Sivustolle. K\xE4ytt\xF6oikeudet on m\xE4\xE4ritelty tarkemmin Sivustolla. K\xE4ytt\xF6ehdot sitovat kaikkia K\xE4ytt\xE4ji\xE4."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi pid\xE4tt\xE4\xE4 oikeuden muuttaa K\xE4ytt\xF6ehtoja. Maap\xF6rssi voi muuttaa K\xE4ytt\xF6ehtoja kokonaan tai osittain. Maap\xF6rssi voi tehd\xE4 muutoksen K\xE4ytt\xF6ehtoihin milloin tahansa. Maap\xF6rssi ilmoittaa K\xE4ytt\xE4jille j\xE4lkik\xE4teen kaikista Sivustolle tehdyist\xE4 muutoksista erillisell\xE4 s\xE4hk\xF6postilla. Maap\xF6rssi l\xE4hett\xE4\xE4 K\xE4ytt\xE4j\xE4lle s\xE4hk\xF6postin K\xE4ytt\xE4j\xE4tilille rekister\xF6ityyn s\xE4hk\xF6postiosoitteeseen. Lis\xE4ksi t\xE4llaiset muutokset merkit\xE4\xE4n suoraan Sivustolta l\xF6ytyviin K\xE4ytt\xF6ehtoihin. Mik\xE4li K\xE4ytt\xE4j\xE4 k\xE4ytt\xE4\xE4 Sivustoa viel\xE4 K\xE4ytt\xF6ehtojen muutosten j\xE4lkeen, tulkitaan t\xE4llainen Sivuston k\xE4ytt\xE4minen muutettujen K\xE4ytt\xF6ehtojen hyv\xE4ksynn\xE4ksi."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Kaikki Sivuston K\xE4ytt\xF6ehtoihin tehdyt muutokset astuvat voimaan v\xE4litt\xF6m\xE4sti, kun niist\xE4 on l\xE4hetetty s\xE4hk\xF6posti kaikille rekister\xF6idyille K\xE4ytt\xE4jille."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "2. M\xC4\xC4RITELM\xC4T"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Alla m\xE4\xE4ritellyt ilmaukset tarkoittavat n\xE4iss\xE4 K\xE4ytt\xF6ehdoissa seuraavaa:"
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Toimittaminen"
                ),
                ": K\xE4ytt\xF6- ja mahdollisten erillisten Myyj\xE4n ja Ostajan v\xE4listen toimitusehtojen mukaisen transaktion perusteella tapahtuva Materiaalien toimittaminen Ostajalle tai K\xE4ytt\xE4j\xE4lle."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Digitaalinen Kuljetusasiakirja"
                ),
                ": Digitaalinen asiakirja, jossa on tiedot kaupan kohteen kuljetuksesta (l\xE4ht\xF6paikka, toimitusosoite, et\xE4isyys, jne.), toimitetut Materiaalit ja kuljettajan tiedot, on vahvistus Toimittamisen toteutumisesta."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Maap\xF6rssi"
                ),
                ": Maap\xF6rssi Oy; Y-tunnus: 2335445-0; osoite: Linnoitustie 6, 02600 Espoo, Suomi; puhelinnumero: 0407698197; s\xE4hk\xF6postiosoite: info@maaporssi.fi."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Materiaalit"
                ),
                ": Kaikenlainen siirrett\xE4v\xE4 materiaali, jota tarjotaan Sivuston v\xE4lityksell\xE4 t\xE4m\xE4n tarkoittaen eritoten rakennusmateriaaleja, maa-aineksia, j\xE4tteit\xE4 jne."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Ilmoitus"
                ),
                ": K\xE4ytt\xE4j\xE4n Sivustolla tiedotus-, myynti-, osto-, vaihto- tai tarjousmieless\xE4 julkaisemat tiedot Materiaaleista tai Kolmannen Tahon Tarjoamista Palveluista."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Hinnasto"
                ),
                ": Asiakirja, jossa on lueteltuna hinnat Maap\xF6rssin tarjoamista Palveluista."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Tietosuojak\xE4yt\xE4nt\xF6"
                ),
                ": Maap\xF6rssin noudattama k\xE4yt\xE4nt\xF6 K\xE4ytt\xE4jist\xE4 saatavien tietojen ker\xE4\xE4misen, k\xE4ytt\xE4misen, s\xE4ilytt\xE4misen ja siirt\xE4misen osalta."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Ostaja"
                ),
                ": K\xE4ytt\xE4j\xE4, joka aikoo ostaa tai vaihtaa yhden tai useamman Materiaalin tai Kolmannen Tahon Tarjoaman Palvelun."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Myyj\xE4"
                ),
                ": K\xE4ytt\xE4j\xE4, joka lataa Sivustolle yhden tai useamman Ilmoituksen aikeinaan tarjota, myyd\xE4 tai vaihtaa Materiaaleja. Maap\xF6rssi voi my\xF6s itse toimia Myyj\xE4n\xE4, jos Maap\xF6rssi itse julkaisee Ilmoituksen."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Palvelut"
                ),
                ": Maap\xF6rssin Sivustolla tarjoamat palvelut, joilla K\xE4ytt\xE4j\xE4t voivat Sivuston s\xE4\xE4nt\xF6j\xE4 noudattaen; esimerkiksi viestitell\xE4 kesken\xE4\xE4n yksityisesti ja tiedottaa, tarjota, myyd\xE4, ostaa tai vaihtaa Materiaaleja tai Kolmannen Tahon Tarjoamia Palveluita."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Sivusto"
                ),
                ": Osoitteessa http://www.maaporssi.fi oleva sivusto."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "K\xE4ytt\xF6ehdot"
                ),
                ": Maap\xF6rssin Sivuston ajantasaiset K\xE4ytt\xF6ehdot, mukaan lukien mahdolliset liitteet, lis\xE4ykset ja muutokset."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Kolmannen Tarjoamat Palvelut"
                ),
                ": Kolmannen Tahon tarjoamat palvelut (esim. kuljetus, kaivanto- ja porauspalvelut, jne.), jotka on julkaistu Sivustolla. T\xE4llaisiin palveluihin voi liitty\xE4 erillisi\xE4 k\xE4ytt\xF6ehtoja. Kolmannen Tahon Tarjoamat Palvelut eiv\xE4t ole Maap\xF6rssin tarjoamia Palveluita eik\xE4 Maap\xF6rssi ota mit\xE4\xE4n vastuuta niist\xE4."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Transaktio"
                ),
                ": Kaikki Ostajan ja Myyj\xE4n v\xE4liset Sivuston v\xE4lityksell\xE4 sovitut oikeustoimet Materiaaleista ja Kolmannen Tahon Tarjoamista Palveluista."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "K\xE4ytt\xE4j\xE4"
                ),
                ": Sivustolle rekister\xF6ityneet ja rekister\xF6itym\xE4tt\xF6m\xE4t henkil\xF6t, jotka k\xE4ytt\xE4v\xE4t Sivustoa."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "K\xE4ytt\xE4j\xE4tili"
                ),
                ": K\xE4ytt\xE4j\xE4n Sivustolle rekister\xF6innin yhteydess\xE4 perustettu oma tili, joka sis\xE4lt\xE4\xE4 tietoja K\xE4ytt\xE4j\xE4st\xE4 ja jonka avulla K\xE4ytt\xE4j\xE4 voi k\xE4ytt\xE4\xE4 Sivuston Palveluita."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Sivuston Sis\xE4lt\xF6"
                ),
                ": Kaikki Sivustolla oleva sis\xE4lt\xF6 kuten tekstit, grafiikat, kuvat, tavaramerkit, logot, Transaktioon liittyv\xE4 kaikenlainen tieto ja muut vastaavat sis\xE4ll\xF6t."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "3. PALVELUT"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssin Sivusto tarjoaa K\xE4ytt\xE4jilleen virtuaalisen k\xE4ytt\xF6alustan, miss\xE4 K\xE4ytt\xE4j\xE4t voivat Sivuston S\xE4\xE4nt\xF6j\xE4 noudattaen tiedottaa, tarjota, myyd\xE4, ostaa tai vaihtaa Materiaaleja tai Kolmannen Tahon Tarjoamia Palveluita. K\xE4ytt\xE4j\xE4t voivat jakaa omia Ilmoituksiaan Sivustolla ja k\xE4ytt\xE4\xE4 muita Sivuston tarjoamia Palveluita."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4n\xE4 oleminen sek\xE4 Ilmoituksien tekeminen ja katseleminen Sivustolla on ilmaista. Maap\xF6rssi perii maksun kaikista muista Palveluista sek\xE4 Hintaluettelossa tarkemmin eritellyist\xE4 Transaktioihin liittyvist\xE4 maksuista ja k\xE4yt\xF6st\xE4."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "3.1. Maap\xF6rssi toimii p\xE4\xE4s\xE4\xE4nt\xF6isesti ainoastaan virtuaalisena k\xE4ytt\xF6alustana"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi ei ole suoraan osallinen Myyjien ja Ostajien v\xE4lisiss\xE4 oikeustoimissa, ellei Maap\xF6rssi itse julkaise ilmoitusta Sivustolla ja toimi t\xE4ten Myyj\xE4n\xE4. T\xE4st\xE4 johtuen Maap\xF6rssi ei voi kontrolloida K\xE4ytt\xE4jien v\xE4lisiss\xE4 Transaktioissa Materiaalien tai Kolmansien Tahojen Tarjoamien Palveluiden laatua, turvallisuutta, moraalisuutta tai laillisuutta. Maap\xF6rssi ei voi my\xF6sk\xE4\xE4n t\xE4ll\xF6in valvoa Ilmoitusten todenmukaisuutta tai paikkansapit\xE4vyytt\xE4 eik\xE4 se lis\xE4ksi voi valvoa Myyjien tai Ostajien myynti- tai maksukykyisyytt\xE4. Maap\xF6rssi ei ennalta tutki K\xE4ytt\xE4ji\xE4 tai K\xE4ytt\xE4jien julkaisemaa sis\xE4lt\xF6\xE4 tai tietoa. Maap\xF6rssi ei voi velvoittaa Myyj\xE4\xE4 tai Ostajaa suorittamaan Transaktiota loppuun. T\xE4st\xE4 johtuen Maap\xF6rssi ei voi siirt\xE4\xE4 laillista omistajuutta esineisiin tai Materiaaleihin eik\xE4 se voi my\xF6sk\xE4\xE4n tuottaa Myyj\xE4n tarjoamia palveluita Ostajalle. Maap\xF6rssi ei voi taata K\xE4ytt\xE4j\xE4n todellista henkil\xF6llisyytt\xE4. Maap\xF6rssi suosittelee K\xE4ytt\xE4ji\xE4 kommunikoimaan suoraan toisen osapuolen kanssa s\xE4hk\xF6postitse, puhelimitse ja tekstiviestitse."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4 hyv\xE4ksyy, ett\xE4 k\xE4ytt\xE4jien v\xE4lisiss\xE4 Transaktioissa Maap\xF6rssi toimii ainoastaan edell\xE4 kuvatulla tavalla virtuaalisena k\xE4ytt\xF6alustana. T\xE4ten K\xE4ytt\xE4j\xE4 hyv\xE4ksyy my\xF6s, ett\xE4 Maap\xF6rssi ei ole vastuussa mist\xE4\xE4n K\xE4ytt\xE4jien tai Kolmansien Tahojen tuottamasta sis\xE4ll\xF6st\xE4 Sivustolla. K\xE4ytt\xE4j\xE4 my\xF6s hyv\xE4ksyy k\xE4ytt\xE4v\xE4ns\xE4 Sivustoa omalla vastuullaan."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi vastaa ainoastaan oman ilmoituksensa synnytt\xE4m\xE4st\xE4 Myyj\xE4n-velvollisuudesta vain ja ainoastaan silloin kuin Maap\xF6rssi itse toimii Myyj\xE4n\xE4. Maap\xF6rssi voi my\xF6s toimia K\xE4ytt\xE4j\xE4n puolesta Sivustolla laittamalla K\xE4ytt\xE4j\xE4n Ilmoituksen Sivustolle K\xE4ytt\xE4j\xE4n pyyt\xE4ess\xE4 sit\xE4 Maap\xF6rssilt\xE4. Tuolloin Maap\xF6rssi toimii ainoastaan siin\xE4 laajuudessa, eli v\xE4lik\xE4ten\xE4. T\xE4ll\xF6inkin ainoastaan K\xE4ytt\xE4j\xE4 vastaa kaikkeen ilmoitukseen liittyv\xE4st\xE4."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "3.2. Ilmoituksen tekeminen Sivustolle ja muut Ilmoitukseen liittyv\xE4t oikeudet"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Myyj\xE4n on ilmoitettava Ilmoituksessaan kaikki siin\xE4 vaaditut tiedot ja kuvailtava Materiaaleja tai Kolmannen Tahon Tarjoamia Palveluita niin kattavasti kuin mahdollista. Myyj\xE4 ei ole sidottu tekem\xE4\xE4ns\xE4 Ilmoitukseen, vaikka t\xE4m\xE4 ilmaisee siin\xE4 myyntihinnan, myyntitavan ja Toimittamisen ehdot. T\xE4ten Ilmoitusta on pidett\xE4v\xE4 vain Ilmoituksena siit\xE4, ett\xE4 Myyj\xE4lle voidaan esitt\xE4\xE4 tarjouksia Ilmoitukseen liittyen."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Myyj\xE4ll\xE4 on aina oikeus poistaa tai muuttaa lataamansa Ilmoituksen."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "3.3. K\xE4ytt\xE4ytyminen Sivustolla ja siell\xE4 olevat tiedot"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi kielt\xE4\xE4 ehdottomasti Sivustolla toisten K\xE4ytt\xE4jien loukkaamisen, rikoksiin ja loukkauksiin yllytt\xE4misen, syrjinn\xE4n, vihapuheen ja kaikenlaisen v\xE4kivaltaisen kielenk\xE4yt\xF6n, v\xE4\xE4rien tai haitallisten uutisten v\xE4litt\xE4misen, kunnianloukkaukset ja muut herjaavat v\xE4itteet, rikkomukset toisten yksityisyyteen, kaiken ep\xE4soveliaan materiaalin lataamisen Sivustolle sek\xE4 niiden k\xE4yt\xF6n sellaiseen tarkoitukseen, joka ei ole lain mukaista tai joka voi vahingoittaa Maap\xF6rssin liiketoiminnan mainetta."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Kaikenlainen K\xE4ytt\xE4j\xE4n antama palaute toisista K\xE4ytt\xE4jist\xE4 tulee olla reilua, totuudenmukaista ja kunnioittavaa. Valehteleminen, toisten loukkaaminen sek\xE4 valheellisten tietojen levitt\xE4minen Sivustolla on ehdottomasti kielletty."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi pid\xE4tt\xE4\xE4 oikeuden poistaa Sivustolta Maap\xF6rssin n\xE4kemysten perusteella tiedon, joka on K\xE4ytt\xF6ehtojen vastainen, virheellinen, loukkaava tai joka loukkaa toisten K\xE4ytt\xE4jien oikeuksia."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "3.5. Maap\xF6rssin oikeus l\xE4hett\xE4\xE4 viestej\xE4 ja tarjouksia K\xE4ytt\xE4j\xE4lle"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi on oikeutettu tekem\xE4\xE4n Ilmoituksia, jotka toimivat tiedotusv\xE4linein\xE4 K\xE4ytt\xE4jille Sivustolle tai kaavailluista uudistuksista (esim. uusien Palveluiden tai K\xE4ytt\xF6ehtojen uudistamisen osalta). Mik\xE4li Sivustolla erikseen julkaistujen erityisten ehtojen ja K\xE4ytt\xF6ehtojen v\xE4lille syntyy ristiriitaisuuksia, on ristiriitaisuudet ratkaistava erityisi\xE4 ehtoja noudattaen."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssill\xE4 on oikeus l\xE4hett\xE4\xE4 K\xE4ytt\xE4j\xE4lle s\xE4hk\xF6postiviestej\xE4 K\xE4ytt\xE4j\xE4n Sivustolle rekister\xF6ityyn s\xE4hk\xF6postiosoitteeseen. Maap\xF6rssi voi l\xE4hett\xE4\xE4 K\xE4ytt\xE4j\xE4lle s\xE4hk\xF6postiviestej\xE4 rekister\xF6innin hetkell\xE4, Palveluihin ja suunnitteilla oleviin uusiin palveluihin liittyen sek\xE4 silloin, kun Maap\xF6rssi katsoo, ett\xE4 viesti voi parantaa K\xE4ytt\xE4j\xE4n tapaa k\xE4ytt\xE4\xE4 Palveluita. T\xE4llaiset s\xE4hk\xF6postiviestit saavat sis\xE4lt\xE4\xE4 muistutuksia, kutsuja, markkinointia, mainossis\xE4lt\xF6\xE4 ja ehdotuksia sek\xE4 kuvauksia olemassa olevista, uusista tai tulevista Palveluista. Mik\xE4li K\xE4ytt\xE4j\xE4 ei halua vastaanottaa markkinointiin taikka mainossis\xE4lt\xF6\xF6n liittyvi\xE4 s\xE4hk\xF6postiviestej\xE4, tulee K\xE4ytt\xE4j\xE4n kirjallisesti ilmoittaa t\xE4st\xE4 Maap\xF6rssille."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "4. TRANSAKTIOT"
              ),
              _react2.default.createElement(
                "h5",
                null,
                "4.1. Materiaalit"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Materiaalit Sivustolla ovat K\xE4ytt\xE4jien v\xE4lill\xE4 ostettavissa, myyt\xE4viss\xE4 tai vaihdettavissa t\xE4m\xE4n kuitenkaan rajoittamatta K\xE4ytt\xE4jien v\xE4lisi\xE4 Transaktioita ja niiden luonnetta. Maap\xF6rssi ei ole osallinen K\xE4ytt\xE4jien solmimissa Transaktioissa. Maap\xF6rssi ei ole siten vastuussa mist\xE4\xE4n t\xE4llaiseen Transaktioon liittyv\xE4st\xE4 velvoitteesta. Maap\xF6rssi voi kuitenkin itse my\xF6s j\xE4tt\xE4\xE4 ilmoituksia Sivustolla ja toimia siten Myyj\xE4n\xE4. Maap\xF6rssi toimii t\xE4ll\xF6in osapuolena Transaktiossa ja vastaa t\xE4ll\xF6in ainoastaan oman ilmoituksensa synnytt\xE4m\xE4st\xE4 Myyj\xE4n-velvollisuudesta toimiessaan Myyj\xE4n\xE4."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Ostajan ja Myyj\xE4n vastuulla on sopia Transaktion ehdoista ja sen toteutumisesta."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "4.2. Kolmannen Tarjoamat Palvelut"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Kolmannen Tahon Tarjoamat Palvelut Sivustolla ovat K\xE4ytt\xE4jien v\xE4lill\xE4 ostettavissa ja myyt\xE4viss\xE4. Maap\xF6rssi ei ole osallinen Transaktiossa, jonka K\xE4ytt\xE4j\xE4t solmivat kesken\xE4\xE4n. Maap\xF6rssi ei ole siten vastuussa mist\xE4\xE4n t\xE4llaisesta Transaktioon liittyv\xE4st\xE4 velvoitteesta. Tietyiss\xE4 tapauksissa Maap\xF6rssi voi toimia v\xE4litt\xE4j\xE4n\xE4, esim. ker\xE4tess\xE4\xE4n maksuja Kolmannen Tahon Tarjoamista Palveluista (esim. vastaanottolipukepalvelu, joka m\xE4\xE4ritell\xE4\xE4n kohdassa 4.3.) tai antaessaan todisteen t\xE4llaisen palvelun k\xE4yt\xF6n maksusta (esim. kuitti). Maap\xF6rssi on ainoastaan hallinnollisessa roolissa toimiessaan edell\xE4 kuvatulla tavalla v\xE4litt\xE4j\xE4n\xE4 Kolmannen Tahon Tarjoamissa Palveluissa. Se ei toimi t\xE4ll\xF6ink\xE4\xE4n varsinaisena osapuolena Transaktiossa."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4 sitoutuu noudattamaan Myyj\xE4n\xE4 toimivan Kolmannen Tahon kauppaehtoja ostaessaan Kolmannen Tahon Tarjoamia Palveluita Sivuston v\xE4lityksell\xE4."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi ei vastaa Kolmannen Tahon Tarjoamien Palveluiden oikeellisuudesta, toteutumisesta tai mist\xE4\xE4n muustakaan siihen liittyv\xE4st\xE4 vastaavasta asiasta. T\xE4ten Maap\xF6rssi ei ole velvollinen korvaamaan vahinkoja, jotka ovat saattaneet synty\xE4 Kolmannen Tahon Tarjoamista Palveluista johtuen."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssill\xE4 on lupa v\xE4litt\xE4\xE4 K\xE4ytt\xE4j\xE4n ilmoittamat yhteystiedot t\xE4llaiselle kolmannelle taholle, mik\xE4li K\xE4ytt\xE4j\xE4 ostaa Kolmannen Tahon Tarjoamia Palveluita Sivuston kautta. T\xE4llaiset tiedot saadaan jakaa ainoastaan t\xE4h\xE4n tarkoitukseen. Maap\xF6rssi ei ole vastuussa Kolmannen Tahon tavasta k\xE4sitell\xE4 tietoja K\xE4ytt\xE4j\xE4st\xE4."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "4.3. Vastaanottolipukepalvelu"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Vastaanottolipukepalvelu mahdollistaa Materiaalien purkamisen tietylle paikalle tiettyyn hintaan. K\xE4ytt\xE4j\xE4 sitoutuu vastaanottolipukepalvelun yleisiin kauppaehtoihin ostamalla vastaanottolipukepalvelun Maap\xF6rssin v\xE4lityksell\xE4."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "4.4. Valitusten k\xE4sittely"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi ei ole osallinen K\xE4ytt\xE4jien v\xE4liseen Transaktioon. Kaikki Materiaaleihin ja Kolmannen Tahon Tarjoamiin Palveluihin liittyv\xE4t valitukset, vaateet, palautukset ja muut vaatimukset on esitett\xE4v\xE4 suoraan Transaktion osapuolelle, eli Ostajalle tai Myyj\xE4lle. Mik\xE4li Maap\xF6rssi toimii Myyj\xE4n\xE4, toimii se ainoastaan siin\xE4 tapauksessa Transaktion osapuolena. Mik\xE4li Maap\xF6rssi ilmoittaa K\xE4ytt\xE4j\xE4n puolesta K\xE4ytt\xE4j\xE4n Ilmoituksen Sivustolle K\xE4ytt\xE4j\xE4n pyyt\xE4ess\xE4 sit\xE4 Maap\xF6rssilt\xE4, toimii Maap\xF6rssi tuolloin ainoastaan siin\xE4 laajuudessa, eli v\xE4lik\xE4ten\xE4. T\xE4ll\xF6inkin ainoastaan K\xE4ytt\xE4j\xE4 vastaa kaikkeen Ilmoitukseen liittyv\xE4st\xE4."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "5. MAKSUT SIVUSTON PALVELUN K\xC4YT\xD6ST\xC4"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssill\xE4 on oikeus saada korvauksia Palvelun k\xE4yt\xF6st\xE4. Korvauksien m\xE4\xE4r\xE4t l\xF6ytyv\xE4t ",
                _react2.default.createElement(
                  "a",
                  { href: "/hinnasto" },
                  "Hinnastosta"
                ),
                " ",
                "tai Maap\xF6rssin ja K\xE4ytt\xE4j\xE4n v\xE4lisest\xE4 sopimuksesta. K\xE4ytt\xE4j\xE4 tiedostaa ja hyv\xE4ksyy, ett\xE4 Maap\xF6rssill\xE4 on oikeus yksipuolisesti muuttaa Hinnastoa. Maap\xF6rssi julkaisee muutokset Hinnastoon Sivustolla. Ellei toisin m\xE4\xE4r\xE4t\xE4, kaikki maksut ovat ilmaistu euroissa. K\xE4ytt\xE4j\xE4 tiedostaa ja hyv\xE4ksyy, ett\xE4 Ammattilaislisenssiin liittyv\xE4 asiakkuus on jatkuva asiakkuus. Keskeytt\xE4\xE4kseen asiakkuuden K\xE4ytt\xE4j\xE4n tai h\xE4nen edustajansa on irtisanottava sopimus kirjallisesti viimeist\xE4\xE4n 1 viikko ennen sopimuksen p\xE4\xE4ttymist\xE4 osoitteeseen",
                " ",
                _react2.default.createElement(
                  "a",
                  { href: "mailto:asiakaspalvelu@maaporssi.fi" },
                  "asiakaspalvelu@maaporssi.fi"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4 ymm\xE4rt\xE4\xE4 ja hyv\xE4ksyy Maap\xF6rssin palautusk\xE4yt\xE4nn\xF6n ostamalla maksullisia Palveluita. Maap\xF6rssin palautusk\xE4yt\xE4nn\xF6n mukaan K\xE4ytt\xE4j\xE4ll\xE4 on oikeus saada Lipukekaupassa Maap\xF6rssille suoritettu maksu palautetuksi kokonaan, jos palautusvaatimus ja k\xE4ytt\xE4m\xE4tt\xF6m\xE4t lipukkeet esitet\xE4\xE4n Maap\xF6rssille 14 vrk kuluessa lipukkeiden ostop\xE4iv\xE4st\xE4 lukien. Maksun palautus on 80 % kun lipukkeiden palautus tapahtuu my\xF6hemmin kuin 14 vrk, mutta ennemmin kuin kolmenkymmenen (30) vrk kuluessa ostop\xE4iv\xE4st\xE4. Vaateet, jotka esitet\xE4\xE4n yli kolmenkymmenen (30) vrk j\xE4lkeen ostop\xE4iv\xE4st\xE4 j\xE4tet\xE4\xE4n huomioimatta. K\xE4ytt\xE4j\xE4ll\xE4 ei ole oikeutta palautuksiin, mik\xE4li K\xE4ytt\xE4j\xE4 tai Maap\xF6rssi poistaa K\xE4ytt\xE4j\xE4n K\xE4ytt\xE4j\xE4tilin."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi ei ole vastuussa palautusvaateista, jotka liittyv\xE4t Sivustolla ilmoitettuihin Materiaaleihin ja Kolmannen Tahon Tarjoamiin Palveluihin."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "6. SIVUSTON K\xC4YTT\xD6\xD6N LIITTYV\xC4T YLEISET VELVOITTEET"
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4 tiedostaa ja hyv\xE4ksyy, ett\xE4 Maap\xF6rssi ei ole vastuussa: (i) mist\xE4\xE4n K\xE4ytt\xE4jien aktiivisista tai passiivisista toimista Sivustoon tai Palveluihin liittyen; (ii) mist\xE4\xE4n K\xE4ytt\xE4j\xE4n Sivustolla julkaisemasta tiedosta, esim. sen oikeellisuudesta tai lainmukaisuudesta; tai (iii) mist\xE4\xE4n K\xE4ytt\xE4jien Sivustolla tarjoamista Materiaaleista tai Kolmannen Tahon Tarjoamista Palveluista."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Jokainen K\xE4ytt\xE4j\xE4 on vastuussa omista Ilmoituksistaan. Jokaisen K\xE4ytt\xE4j\xE4n on noudatettava voimassaolevaa lains\xE4\xE4d\xE4nt\xF6\xE4. K\xE4ytt\xE4jien on etenkin v\xE4ltett\xE4v\xE4: (a) Kolmannen Tahon oikeuksien loukkaamista; (b) v\xE4\xE4rien tai luvattomien uutisten levitt\xE4mist\xE4; (c) toisten henkil\xF6iden yksityisyyden loukkaamista; tai (d) toisten henkil\xF6iden identiteetin k\xE4ytt\xE4mist\xE4. Lista ei ole tyhjent\xE4v\xE4."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4 tiedostaa ja hyv\xE4ksyy, ett\xE4 Maap\xF6rssi ei ole vastuussa K\xE4ytt\xE4jien v\xE4lisist\xE4 Sivuston v\xE4lityksell\xE4 ostetuista tai myydyist\xE4 Materiaaleista taikka Kolmannen Tahon Tarjoamien Palveluiden laadusta, m\xE4\xE4r\xE4st\xE4 tai niiden oikeellisuudesta. Jokainen K\xE4ytt\xE4j\xE4 on itse vastuussa tiedoista, joita h\xE4n jakaa Sivustolla sek\xE4 Materiaaleista ja Kolmannen Tahon Tarjoamista Palveluista, joita h\xE4n jakaa, myy tai muuten v\xE4litt\xE4\xE4 muille K\xE4ytt\xE4jille Sivustolla. K\xE4ytt\xE4j\xE4 tiedostaa ja hyv\xE4ksyy, ett\xE4: (i) Maap\xF6rssi ei ole vastuussa mist\xE4\xE4n vahingosta mik\xE4 on voinut seurata suoraan tai v\xE4lillisesti toisten K\xE4ytt\xE4jien Sivustolla jakaman tiedon perusteella; ja (ii) ainoastaan tiedonv\xE4litt\xE4j\xE4 on vastuussa Sivustolla julkaistun tiedon oikeellisuudesta sek\xE4 sen lainmukaisuudesta. Maap\xF6rssi ei tarkista K\xE4ytt\xE4j\xE4n Sivustolla jakamaa tietoa jakamishetkell\xE4."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Ainoastaan K\xE4ytt\xE4j\xE4t ovat vastuussa K\xE4ytt\xE4jien v\xE4lisist\xE4 Transaktioista. K\xE4ytt\xE4j\xE4t ovat siten vastuussa heid\xE4n kesken\xE4\xE4n sopimista kauppaehdoista sek\xE4 riidoista, jotka liittyv\xE4t Materiaalien Toimitukseen, Kolmannen Tahon Tarjoamiin Palveluihin, K\xE4ytt\xE4jien v\xE4lisiin suhteisiin, Sivustoon sek\xE4 Palveluihin."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4 tiedostaa ja hyv\xE4ksyy, ett\xE4 Maap\xF6rssi ei ole vastuussa (i) Transaktion lainmukaisuudesta; eik\xE4 (ii) mist\xE4\xE4n Ostajan ja Myyj\xE4n v\xE4lille syntyv\xE4st\xE4 riidasta. Maap\xF6rssi ei osallistu Ostajan ja Myyj\xE4n v\xE4lille syntyvien riitojen k\xE4sittelyyn milt\xE4\xE4n osin. Ostajan ja Myyj\xE4n on ratkaistava riitansa voimassaolevaa lains\xE4\xE4d\xE4nt\xF6\xE4 noudattaen. Mik\xE4li Maap\xF6rssi toimii Myyj\xE4n\xE4, toimii se ainoastaan siin\xE4 laajuudessa, eli Transaktion osapuolena."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "7. K\xC4YTT\xC4J\xC4N OIKEUDET JA VELVOLLISUUDET SEK\xC4 K\xC4YTT\xC4J\xC4N VAKUUTUS SIIT\xC4, ETT\xC4 H\xC4N K\xC4YTT\xC4\xC4 SIVUSTOA S\xC4\xC4NT\xD6JEN MUKAISESTI"
              ),
              _react2.default.createElement(
                "h5",
                null,
                "7.1. K\xE4ytt\xE4j\xE4n oikeudet ja velvollisuudet"
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4n on noudatettava seuraavia k\xE4yt\xE4nt\xF6j\xE4: (i) K\xE4ytt\xE4j\xE4n on esitett\xE4v\xE4 oikeat tiedot itsest\xE4\xE4n rekister\xF6ityess\xE4\xE4n Sivustolle; (ii) K\xE4ytt\xE4j\xE4ll\xE4 saa olla vain yksi rekister\xF6ity K\xE4ytt\xE4j\xE4tili Sivustolla; (iii) K\xE4ytt\xE4j\xE4n K\xE4ytt\xE4j\xE4tili\xE4 saa k\xE4ytt\xE4\xE4 vain K\xE4ytt\xE4j\xE4 itse yhdell\xE4 laitteella kerrallaan; (iv) K\xE4ytt\xE4j\xE4 ei saa k\xE4ytt\xE4\xE4 Sivustoa tai Palveluita laittomuuksiin tai petoksiin; (v) K\xE4ytt\xE4j\xE4n on annettava objektiivista, paikkansapit\xE4v\xE4\xE4, kattavaa ja yksil\xF6ity\xE4 tietoa Materiaaleista ja Kolmannen Tahon Tarjoamista Palveluista; (vi) K\xE4ytt\xE4j\xE4 ei saa kopioida tai muutoinkaan laittomasti k\xE4ytt\xE4\xE4 tietoa, joka on julkaistu Sivustolla Maap\xF6rssin tai toisen K\xE4ytt\xE4j\xE4n toimesta; ja (vii) K\xE4ytt\xE4j\xE4n on varmistettava, ett\xE4 Ilmoitusten tiedot pit\xE4v\xE4t paikkansa."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4t eiv\xE4t saa Sivustoa ja Palveluita k\xE4ytt\xE4ess\xE4\xE4n: (i) ladata Sivustolle harhaanjohtavaa tai valheellista tietoa; (ii) mainostaa sellaisen esineen, Materiaalin tai palvelun myynti\xE4, jonka kierr\xE4tt\xE4minen on laissa rajoitettu tai kokonaan kielletty; (iii) loukata omistusoikeuksia, immateriaalioikeudet mukaan lukien; (iv) toimia lainvastaisesti; ja (v) ladata Sivustolle tietoa, joka on lainvastaista, sis\xE4lt\xE4\xE4 viruksia tai muita tietokoneohjelmia taikka tiedostoja, jotka voivat (a) h\xE4irit\xE4 Sivuston tai Palveluiden normaalia k\xE4ytett\xE4vyytt\xE4, tai (b) aiheuttaa vahinkoa muille K\xE4ytt\xE4jille tai heid\xE4n omaisuudelleen, taikka (c) est\xE4\xE4 muita K\xE4ytt\xE4ji\xE4 k\xE4ytt\xE4m\xE4st\xE4 Sivustoa, Palveluja tai muiden K\xE4ytt\xE4jien k\xE4ytt\xE4m\xE4\xE4 laitetta."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi ei ole vastuussa mist\xE4\xE4n K\xE4ytt\xE4j\xE4n Sivustolla Palveluita hy\xF6dynt\xE4en tapahtuvasta k\xE4yt\xF6ksest\xE4 tai toiminnasta. Maap\xF6rssi ei etenk\xE4\xE4n ole vastuussa K\xE4ytt\xE4j\xE4n Transaktioon liittyv\xE4n suorituksen kokonaisesta tai osittaisesta laiminly\xF6nnist\xE4. Mik\xE4li K\xE4ytt\xE4j\xE4tili on luotu organisaation k\xE4ytt\xF6\xE4 varten, organisaatio voi olla vastuussa sen ty\xF6ntekij\xF6iden tai muiden edustajien toimista, joita he tekev\xE4t t\xE4t\xE4 K\xE4ytt\xE4j\xE4tili\xE4 k\xE4ytt\xE4en."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4t ovat vastuussa salasanojensa ja K\xE4ytt\xE4j\xE4tiliens\xE4 luottamuksellisuudesta. K\xE4ytt\xE4j\xE4t ovat siten itse vastuussa kaikista toimista, jotka tapahtuvat heid\xE4n salasanojensa tai K\xE4ytt\xE4j\xE4tiliens\xE4 toimesta. K\xE4ytt\xE4j\xE4t hyv\xE4ksyv\xE4t, ett\xE4 heid\xE4n: (i) on ilmoittava v\xE4litt\xF6m\xE4sti Maap\xF6rssille kaikesta heid\xE4n salasanojensa tai K\xE4ytt\xE4j\xE4tiliens\xE4 luvattomasta k\xE4yt\xF6st\xE4 sek\xE4 muista tietoturvaloukkauksista, ja (ii) on kirjauduttava ulos heid\xE4n K\xE4ytt\xE4j\xE4tililt\xE4\xE4n, kun he lopettavat Sivustolla vierailun. Maap\xF6rssi ei ole vastuussa mist\xE4\xE4n menetyksest\xE4 tai vahingosta mik\xE4 seuraa siit\xE4, ett\xE4 K\xE4ytt\xE4j\xE4 ei ole noudattanut edell\xE4 mainittuja velvoitteita."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4n on viivytyksett\xE4 p\xE4ivitett\xE4v\xE4 kaikki vanhentunut, ep\xE4oleellinen tai virheellinen tieto, joka koskee K\xE4ytt\xE4j\xE4\xE4 itse\xE4\xE4n tai K\xE4ytt\xE4j\xE4n vastuulla olevia Materiaaleja tai Kolmannen Tahon Tarjoamia Palveluita."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "7.2. K\xE4ytt\xE4j\xE4n vakuutus siit\xE4, ett\xE4 h\xE4n k\xE4ytt\xE4\xE4 Sivustoa s\xE4\xE4nt\xF6jen mukaisesti"
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4 vakuuttaa, ett\xE4 Sivustoa k\xE4ytt\xE4ess\xE4\xE4n h\xE4n, ja k\xE4ytt\xE4ess\xE4\xE4n Sivustoa organisaationsa puolesta vakuuttaa, ett\xE4 h\xE4nen organisaationsa: (i) on t\xE4ysivaltainen; (ii) noudattaa tunnollisesti kaikkia velvollisuuksia, jotka on asetettu n\xE4iss\xE4 K\xE4ytt\xF6ehdoissa sek\xE4 muissa Sivuston S\xE4\xE4nn\xF6iss\xE4; (iii) on itsen\xE4isesti ja t\xE4ysin vastuussa kaikista solmimistaan Transaktioista; (iv) Ostajana toimiessaan ja Transaktioon sitoutuessaan ostaa sek\xE4 maksaa Materiaalit ja Kolmannen Tahon Tarjoaman Palvelun; (v) Ostajana toimiessaan ymm\xE4rt\xE4\xE4 Transaktion laiminly\xF6nnin voivan johtaa velvollisuuteen korvata kaikki siit\xE4 johtuvat tappiot Myyj\xE4lle; (vi) maksaa kaikki mahdolliset veroseuraamukset, jotka seuraavat Palvelujen k\xE4yt\xF6st\xE4 ja Transaktioiden tekemisest\xE4; ja (vii) maksaa viivytyksett\xE4 Maap\xF6rssille k\xE4ytt\xE4mist\xE4\xE4n maksullisista Palveluista, joiden hinnat ja k\xE4yt\xE4nn\xF6t l\xF6ytyv\xE4t",
                _react2.default.createElement(
                  "a",
                  { href: "/hinnasto" },
                  "Hinnastosta"
                ),
                " ja/tai Maap\xF6rssin ja K\xE4ytt\xE4j\xE4n v\xE4lisest\xE4 sopimuksesta."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "8. MAAP\xD6RSSIN OIKEUDET JA VELVOLLISUUDET"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssill\xE4 on yksipuolinen ja itsen\xE4inen oikeus rajoittaa tai poistaa K\xE4ytt\xE4jien k\xE4ytt\xF6oikeuksia Sivustolle. Maap\xF6rssill\xE4 on siten oikeus: (i) poistaa K\xE4ytt\xE4j\xE4n K\xE4ytt\xE4j\xE4tili tai K\xE4ytt\xE4j\xE4n lataamia tietoja Sivustolle; sek\xE4 (ii) est\xE4\xE4 K\xE4ytt\xE4j\xE4\xE4 uudelleen rekister\xF6itym\xE4st\xE4 tai p\xE4\xE4sem\xE4st\xE4 uudelleen Sivustolle."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssill\xE4 on yksipuolinen ja itsen\xE4inen oikeus ilmoituksetta est\xE4\xE4 kokonaan tai osittain K\xE4ytt\xE4j\xE4n p\xE4\xE4sy Sivustolle. Maap\xF6rssi voi est\xE4\xE4 K\xE4ytt\xE4j\xE4n p\xE4\xE4syn Sivustolle, mik\xE4li K\xE4ytt\xE4j\xE4 rikkoo jotain n\xE4iss\xE4 K\xE4ytt\xF6ehdoissa asetettua kieltoa. Kiellon seurauksena K\xE4ytt\xE4j\xE4 saattaa menett\xE4\xE4 oikeutensa k\xE4ytt\xE4\xE4 Sivustoa tai vastaanottaa mit\xE4\xE4n sen tarjoamia Palveluita."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssill\xE4 on oikeus valvoa K\xE4ytt\xE4j\xE4n toimia Sivustolla. Valvonnan tarkoitus on poistaa laiton sis\xE4lt\xF6 Sivustolta ja siksi valvonta suoritetaan t\xE4t\xE4 silm\xE4ll\xE4 pit\xE4en. K\xE4ytt\xE4j\xE4t hyv\xE4ksyv\xE4t Maap\xF6rssin valvonnan t\xE4ss\xE4 laajuudessa. Maap\xF6rssill\xE4 on oikeus ker\xE4t\xE4 tietoa K\xE4ytt\xE4j\xE4n k\xE4ytt\xE4ytymisest\xE4 Sivustolla. T\xE4ll\xF6in tarkoituksena on suojella K\xE4ytt\xE4ji\xE4 petoksilta, huonoilta Transaktioilta sek\xE4 muilta loukkauksilta ja siksi tietojen ker\xE4\xE4minen suoritetaan t\xE4t\xE4 silm\xE4ll\xE4 pit\xE4en. K\xE4ytt\xE4j\xE4t hyv\xE4ksyv\xE4t Maap\xF6rssin toimittaman tietojen ker\xE4\xE4misen t\xE4ss\xE4 laajuudessa."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssill\xE4 on oikeus muuttaa Sivustoa k\xE4ytt\xE4j\xE4yst\xE4v\xE4llisemm\xE4ksi sek\xE4 Sivuston tarkoitusta paremmin palvelevaksi. Maap\xF6rssill\xE4 on siten oikeus muuttaa Ilmoituksia, jotta ne palvelevat t\xE4t\xE4 tarkoitusta."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssill\xE4 on yksipuolinen ja itsen\xE4inen oikeus lopettaa sopimussuhde K\xE4ytt\xE4j\xE4n ja Maap\xF6rssin v\xE4lill\xE4 noudattaen n\xE4it\xE4 K\xE4ytt\xF6ehtoja tai muita osapuolten v\xE4lill\xE4 sovittuja s\xE4\xE4nt\xF6j\xE4. Maap\xF6rssin on t\xE4ll\xF6in annettava kirjallinen tiedote K\xE4ytt\xE4j\xE4lle ennen oikeussuhteen p\xE4\xE4tt\xE4mist\xE4, miss\xE4 kerrotaan Maap\xF6rssin aikeista lopettaa oikeussuhde sen ja K\xE4ytt\xE4j\xE4n v\xE4lill\xE4. K\xE4ytt\xE4j\xE4ll\xE4 on tiedote saatuaan velvollisuus lopettaa h\xE4nen ja Maap\xF6rssin v\xE4linen sopimussuhde heti, kun K\xE4ytt\xE4j\xE4 on suorittanut kaikki h\xE4nen velvoitteensa ja poistanut h\xE4nen K\xE4ytt\xE4j\xE4tilins\xE4 Sivustolta."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssill\xE4 on yksipuolinen ja itsen\xE4inen oikeus lopettaa, keskeytt\xE4\xE4 tai siirt\xE4\xE4 kolmannelle taholle Sivuston toiminta. Maap\xF6rssin on t\xE4ll\xF6in sille k\xE4yt\xE4nn\xF6llisell\xE4 tavalla ilmoitettava K\xE4ytt\xE4jille t\xE4llaisista muutoksista."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4ll\xE4 ei ole oikeutta saada mit\xE4\xE4n jo suoritettuja maksuja (esim. vastaanottolipukepalvelu, vuosittainen Maap\xF6rssille suoritettava maksu Palvelun k\xE4yt\xF6st\xE4, jne.) takaisin sen johdosta, ett\xE4 h\xE4nen K\xE4ytt\xE4j\xE4tilins\xE4 tai Sivusto on poistettu."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "9. TIEDOT K\xC4YTT\xC4J\xC4ST\xC4"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi k\xE4sittelee hallussaan olevia henkil\xF6tietoja voimassaolevan lains\xE4\xE4d\xE4nn\xF6n ja Tietosuojak\xE4yt\xE4nn\xF6n/Rekisteriselosteen mukaisesti."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi voi Tietosuojak\xE4yt\xE4nt\xF6\xE4 noudattaen k\xE4ytt\xE4\xE4 K\xE4ytt\xE4jist\xE4 ker\xE4tty\xE4 muuta tietoa kuin henkil\xF6tietoja sis\xE4ist\xE4 liiketoimintaa sek\xE4 markkinointia varten ja tilastollisiin tarkoituksiin. Maap\xF6rssi voi jakaa K\xE4ytt\xE4jist\xE4 muuta tietoa kuin henkil\xF6tietoja kolmansille tahoille tilastollisiin tarkoituksiin. T\xE4ll\xF6in tiedot K\xE4ytt\xE4jist\xE4 annetaan tunnistamattomana tietona siten, ettei niit\xE4 voida yhdist\xE4\xE4 tai j\xE4ljitt\xE4\xE4 takaisin K\xE4ytt\xE4j\xE4\xE4n. Viranomaisilla voi olla lainmukainen oikeus saada K\xE4ytt\xE4j\xE4st\xE4 tietoja. T\xE4ll\xF6inkin Maap\xF6rssi noudattaa voimassaolevaa lains\xE4\xE4d\xE4nt\xF6\xE4 harkitessaan tietojen luovuttamista."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4n K\xE4ytt\xE4j\xE4tilin poistamisen seurauksena Maap\xF6rssi ei v\xE4ltt\xE4m\xE4tt\xE4 poista kaikkia tiliin liittyvi\xE4 muita tietoja kuin henkil\xF6tietoja. T\xE4llaisten tietojen poistaminen on Maap\xF6rssin harkinnanvarassa ja Maap\xF6rssi voi p\xE4\xE4tt\xE4\xE4 s\xE4ilytt\xE4\xE4 sek\xE4 varastoida t\xE4llaisia tietoja Tietosuojak\xE4yt\xE4nn\xF6n mukaisesti. Tietosuojak\xE4yt\xE4nn\xF6n mukaan t\xE4llaisia tietoja voidaan s\xE4ilytt\xE4\xE4: (i) esitutkintaan liittyen; (ii) mik\xE4li laki niin vaatii; (iii) mik\xE4li Maap\xF6rssi tarvitsee tietoja kanteen tekemiseen K\xE4ytt\xE4j\xE4\xE4 vastaan t\xE4m\xE4n rikottua K\xE4ytt\xF6ehtoja, Tietosuojak\xE4yt\xE4nt\xF6\xE4 tai muita Sivuston S\xE4\xE4nt\xF6j\xE4; (iv) tilastollisia tarkoituksia varten; (v) Palveluiden parantamista varten; ja (vi) k\xE4ytt\xE4j\xE4kokemuksen parantamista varten (esim. uusien K\xE4ytt\xE4jien rekister\xF6innin helpottaminen). K\xE4ytt\xE4j\xE4tilin poistamisen yhteydess\xE4 K\xE4ytt\xE4j\xE4 voi antaa Maap\xF6rssille luvan s\xE4ilytt\xE4\xE4 t\xE4m\xE4n henkil\xF6tietoja viel\xE4 K\xE4ytt\xE4j\xE4tilin poistamisen j\xE4lkeen. T\xE4ll\xF6in tarkoituksena on helpottaa K\xE4ytt\xE4j\xE4n mahdollista uudelleen rekister\xF6itymist\xE4 Sivustolle. Henkil\xF6tietojen k\xE4sittelyn, ker\xE4\xE4misen, s\xE4ilytt\xE4misen ja kaikenlaisen muun k\xE4yt\xF6n osalta Maap\xF6rssi noudattaa voimassaolevaa lains\xE4\xE4d\xE4nt\xF6\xE4."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "10. MUUT EHDOT"
              ),
              _react2.default.createElement(
                "h5",
                null,
                "10.1. Sivuston Sis\xE4lt\xF6"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Sivuston Sis\xE4lt\xF6 on suojattu tekij\xE4noikeuksilla ja muilla Suomen sek\xE4 kansainv\xE4lisen lains\xE4\xE4d\xE4nn\xF6n turvaamilla immateriaalioikeuksilla. Sis\xE4ll\xF6n luvaton k\xE4ytt\xF6 saattaa rikkoa tekij\xE4noikeuksia sek\xE4 tavaramerkki- ja muita lakeja. Sis\xE4lt\xF6\xE4 ei saa luvatta kaupallisessa tai miss\xE4\xE4n muussakaan mieless\xE4 myyd\xE4, muuttaa, j\xE4ljent\xE4\xE4, n\xE4ytt\xE4\xE4, esitt\xE4\xE4 julkisesti, jakaa tai mitenk\xE4\xE4n muutoinkaan k\xE4ytt\xE4\xE4. Sis\xE4ll\xF6n k\xE4ytt\xE4minen muilla verkkosivuilla mihin tahansa tarkoitukseen on kielletty."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "10.2. Maap\xF6rssi ei voi taata Sivuston Sis\xE4ll\xF6n paikkansapit\xE4vyytt\xE4"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi ei anna takeita Sivuston Sis\xE4ll\xF6n oikeellisuudesta, luotettavuudesta, t\xE4ydellisyydest\xE4 tai ajantasaisuudesta. Maap\xF6rssi ei my\xF6sk\xE4\xE4n anna takeita siit\xE4, millaisia tuloksia voidaan saavuttaa k\xE4ytt\xE4m\xE4ll\xE4 Sivustoa ja Materiaaleja. K\xE4ytt\xE4j\xE4 k\xE4ytt\xE4\xE4 Sivustoa ja Sivuston Sis\xE4lt\xF6\xE4 omalla vastuullaan. Sivustoa muutetaan s\xE4\xE4nn\xF6llisin v\xE4liajoin ja muutoksia voidaan tehd\xE4 milloin vain."
              ),
              _react2.default.createElement(
                "p",
                null,
                "MAAP\xD6RSSI EI TAKAA, ETT\xC4 SIVUSTO TOIMII VIRHEITT\xC4 EIK\xC4 MY\xD6SK\xC4\xC4N SIT\xC4, ETT\xC4 SIVUSTOSSA JA SEN SERVERISS\xC4 EI OLE TIETOKONEVIRUKSIA TAI MUITA VAHINGOLLISIA ASIOITA. MAAP\xD6RSSI EI OLE VASTUUSSA KULUISTA, JOTKA SEURAAVAT SIVUSTON TAI SIVUSTON SIS\xC4LL\xD6N K\xC4YT\xD6ST\xC4, JOTKA JOHTAVAT TARPEESEEN HUOLTAA TAI KORVATA V\xC4LINEIT\xC4 TAIKKA TIETOA."
              ),
              _react2.default.createElement(
                "p",
                null,
                "SIVUSTO, PALVELUT JA SIVUSTON SIS\xC4LT\xD6 TARJOTAAN SELLAISINA KUIN NE KULLOINKIN OVAT. MAAP\xD6RSSI EI SIIS ANNA MIT\xC4\xC4N TAKEITA SIVUSTOSTA, PALVELUSTA TAI SIVUSTON SIS\xC4LL\xD6ST\xC4."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "10.3. Maap\xF6rssin rajoitettu vastuu"
              ),
              _react2.default.createElement(
                "p",
                null,
                "MAAP\xD6RSSI EI OLE VASTUUSSA MIST\xC4\xC4N VAHINGOSTA, MIK\xC4 ON SEURANNUT SIVUSTON K\xC4YT\xD6ST\xC4 TAI KYVYTT\xD6MYYDEST\xC4 K\xC4YTT\xC4\xC4 SIVUSTOA, PALVELUISTA, KOLMANNEN TAHON TARJOAMISTA PALVELUISTA TAI MATERIAALEISTA. RIIPPUMATTA SIIT\xC4 MIHIN VASTUU PERUSTUU. MAAP\xD6RSSI EI OLE VASTUUSSA T\xC4LLAISESTA VAHINGOSTA SILLOINKAAN, KUN SILLE ON ENNAKKOON ILMOITETTU T\xC4LLAISTEN VAHINKOJEN MAHDOLLISUUDESTA. MAAP\xD6RSSI NIMENOMAISESTI KIELT\xC4YTYY ANTAMASTA MIT\xC4\xC4N TAKUITA SIVUSTON TAI PALVELUIDEN MYYNTIKELPOISUUDESTA, SOPIVUUDESTA TIETTYYN TARKOITUKSEEN TAI LOUKKAAMATTOMUUDESTA."
              ),
              _react2.default.createElement(
                "p",
                null,
                "SILT\xC4 OSIN KUIN SOVELLETTAVA LAINS\xC4\xC4D\xC4NT\xD6 SEN SALLII, MAAP\xD6RSSIN VASTUU KAIKISTA VAATEISTA, JOTKA PERUSTUVAT SIVUSTOON, PALVELUIHIN JA SIVUSTON SIS\xC4LT\xD6\xD6N RAJOITTUU JOKA TAPAUKSESSA SATAAN (100) EUROON."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "10.4. Vahingonkorvaukset"
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4 sitoutuu vapauttamaan vastuusta Maap\xF6rssin, sen toimihenkil\xF6t, johtajat, ty\xF6ntekij\xE4t ja edustajat ja puolustamaan n\xE4it\xE4 kustannuksellaan koskien kaikkia mahdollisia vaatimuksia, jotka on nostettu K\xE4ytt\xE4j\xE4n toimesta tai t\xE4t\xE4 vastaan K\xE4ytt\xF6ehtojen rikkomisesta tai Sivuston, Palveluiden taikka Sivuston Sis\xE4ll\xF6n k\xE4yt\xF6st\xE4 johtuen. Maap\xF6rssi ilmoittaa tiedon saatuaan K\xE4ytt\xE4j\xE4lle viivytyksett\xE4 t\xE4llaisista Maap\xF6rssiin kohdistetuista vaatimuksista Maap\xF6rssi avustaa K\xE4ytt\xE4j\xE4\xE4 puolustautumisessa vaatimuksia vastaan. K\xE4ytt\xE4j\xE4 on kuitenkin itse rahallisessa vastuussa puolustuksestaan."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "10.5. K\xE4ytt\xE4j\xE4n julkaisemat tiedot Sivustolla"
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4n julkaisemat tiedot Sivustolla ovat julkisia. K\xE4ytt\xE4j\xE4n julkaistessa viestin tai tiedon Sivustolla, K\xE4ytt\xE4j\xE4 antaa Maap\xF6rssille automaattisesti luvan k\xE4ytt\xE4\xE4, j\xE4ljent\xE4\xE4, muuttaa, julkaista, k\xE4\xE4nt\xE4\xE4 toiselle kielelle, jakaa, suorittaa tai n\xE4ytt\xE4\xE4 viestinn\xE4n muille. Maap\xF6rssi s\xE4ilytt\xE4\xE4 kaikki viestit ja tiedot mit\xE4 K\xE4ytt\xE4j\xE4 julkaisee Sivustolla. Maap\xF6rssi voi k\xE4ytt\xE4\xE4 t\xE4llaisia viestej\xE4 ja tietoja, vaikka K\xE4ytt\xE4j\xE4 poistaisikin t\xE4llaisen viestin taikka tiedon tai K\xE4ytt\xE4j\xE4n K\xE4ytt\xE4j\xE4tili poistettaisiin."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "10.6. Hyperlinkit, jotka johtavat toisille verkkosivuille"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Sivustolla voi olla hyperlinkkej\xE4, jotka viev\xE4t K\xE4ytt\xE4j\xE4n Kolmannen Tahon verkkosivustolle. Maap\xF6rssi ei ole vastuussa Kolmannen Tahon verkkosivuilla olevasta sis\xE4ll\xF6st\xE4 eik\xE4 Maap\xF6rssi anna mink\xE4\xE4nlaisia takeita Kolmannen Tahon verkkosivujen sis\xE4ll\xF6st\xE4. K\xE4ytt\xE4j\xE4 toimii omalla vastuullaan siirtyess\xE4\xE4n Kolmannen Tahon verkkosivuille Sivustolla olevan hyperlinkin kautta."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "10.7. Oikeudelliset toimenpiteet"
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4t hyv\xE4ksyv\xE4t sen, ett\xE4 Maap\xF6rssi\xE4 ja sen johtajia, ty\xF6ntekij\xF6it\xE4 ja agentteja ei pidet\xE4 vastuussa mist\xE4\xE4n valituksista, vaatimuksista, menetyksist\xE4, korvauksista ja kuluista (kuten asianajajan palkkiot), jotka johtuvat tai aiheutuvat siit\xE4, ett\xE4 (i) Sivuston Palveluita tai Palveluiden kautta hankittuja palveluita tai tuotteita k\xE4ytet\xE4\xE4n; (ii) K\xE4ytt\xE4j\xE4 rikkoo n\xE4it\xE4 K\xE4ytt\xF6ehtoja; (iii) Maap\xF6rssi k\xE4ytt\xE4\xE4 K\xE4ytt\xE4j\xE4n sis\xE4lt\xF6\xE4; tai (iv) K\xE4ytt\xE4j\xE4 rikkoo joitakin Kolmannen Tahon palveluntarjoajan oikeuksia."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Jollei n\xE4iss\xE4 K\xE4ytt\xF6ehdoissa toisin esitet\xE4, n\xE4ihin K\xE4ytt\xF6ehtoihin sovelletaan yksinomaan Suomen lains\xE4\xE4d\xE4nt\xF6\xE4, pois sulkien sen lainvalintaperiaatteita koskevat s\xE4\xE4nn\xF6t. N\xE4ihin K\xE4ytt\xF6ehtoihin liittyv\xE4t tai niiden yhteydess\xE4 mill\xE4 tahansa tavalla syntyv\xE4t mm. K\xE4ytt\xF6ehtojen lainvoimaisuutta, tulkintaa tai t\xE4yt\xE4nt\xF6\xF6npanokelpoisuutta koskevat erimielisyydet, ristiriidat tai kiistat ratkaistaan L\xE4nsi-Uudenmaan k\xE4r\xE4j\xE4oikeudessa."
              ),
              _react2.default.createElement(
                "h5",
                null,
                "10.8. Yleist\xE4"
              ),
              _react2.default.createElement(
                "p",
                null,
                "N\xE4m\xE4 K\xE4ytt\xF6ehdot toimivat sopimuksen tavoin. N\xE4m\xE4 K\xE4ytt\xF6ehdot ovat siten p\xE4tev\xE4 ja voimassa oleva sopimus K\xE4ytt\xE4j\xE4n ja Maap\xF6rssin v\xE4lill\xE4 Sivuston k\xE4yt\xF6st\xE4. N\xE4m\xE4 K\xE4ytt\xF6ehdot pysyv\xE4t p\xE4tevin\xE4 ja voimassaolevina vaikka jokin K\xE4ytt\xF6ehtojen s\xE4\xE4nn\xF6s todettaisiin toimivaltaisen tuomioistuimen toimesta p\xE4tem\xE4tt\xF6m\xE4ksi. T\xE4ll\xF6in ainoastaan tuo s\xE4\xE4nn\xF6s on p\xE4tem\xE4t\xF6n, muun sopimuksen s\xE4ilytt\xE4ess\xE4 p\xE4tevyytens\xE4 ja voimassaolonsa. K\xE4ytt\xE4j\xE4 sitoutuu noudattamaan kaikkia K\xE4ytt\xF6ehtojen s\xE4\xE4nn\xF6ksi\xE4."
              ),
              _react2.default.createElement(
                "p",
                null,
                "N\xE4m\xE4 K\xE4ytt\xF6ehdot muodostavat koko sopimuksen ja osapuolten yhteisymm\xE4rryksen, joka koskee niiden asiasis\xE4lt\xF6\xE4 ja korvaa tai ohittaa kaikki aikaisemmat tai samanaikaiset sopimukset ja yritykset, jotka koskevat kyseist\xE4 asiasis\xE4lt\xF6\xE4."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Maap\xF6rssi ei ole vastuussa K\xE4ytt\xE4j\xE4lle sopimuksen mukaisten velvoitteidensa t\xE4ytt\xE4m\xE4tt\xE4 j\xE4tt\xE4misest\xE4 tai laiminly\xF6nneist\xE4 silloin, kun laiminly\xF6nti tai viiv\xE4styminen johtuu syyst\xE4, joka on Maap\xF6rssin vaikutusmahdollisuuksien ulkopuolella (\u201DYlivoimainen este\u201D). Ylivoimainen este sis\xE4lt\xE4\xE4, ilman rajoituksia, lakot, ty\xF6sulut tai tuotannolliset h\xE4iri\xF6t, keskeytykset tiedon tai s\xE4hk\xF6n siirroissa, laitteiden rikkoutumisen, sodan, mellakan, tulipalon, tulvan ja myrskyn."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4 ei saa luovuttaa tai siirt\xE4\xE4 sopimussuhdetta kokonaisuudessaan tai osittain ulkopuoliselle taholle ilman Maap\xF6rssin ennalta antamaa kirjallista lupaa. K\xE4ytt\xE4j\xE4 antaa Maap\xF6rssille luvan luovuttaa tai siirt\xE4\xE4 sopimussuhteen kokonaisuudessaan tai osittain esimerkiksi (i) alihankkijalle tai sisarliikkeelle; (ii) Maap\xF6rssin p\xE4\xE4oman, liiketoimen tai omaisuuden ostajalle tai (iii) liiketoiminnan jatkajalle fuusiossa. K\xE4ytt\xE4j\xE4n ja Maap\xF6rssin tai mink\xE4\xE4n kolmannen osapuolen palveluntarjoajan v\xE4lille ei synny liiketoiminta-, kumppanuus-, agentti- tai ty\xF6suhdetta Maap\xF6rssin Palvelujen k\xE4yt\xF6n perusteella."
              ),
              _react2.default.createElement(
                "h3",
                null,
                "Rekisteriseloste"
              ),
              _react2.default.createElement(
                "p",
                null,
                "T\xE4ss\xE4 tietosuojaselosteessa on kuvattu Maap\xF6rssi Oy:n tarjoaman www.maaporssi.fi -sivuston (\u201DSivusto\u201D) ja MaaApp-kuljetusapplikaation (\u201DKuljetusapplikaatio\u201D) yhteydess\xE4 suorittama henkil\xF6tietojen k\xE4sittely."
              ),
              _react2.default.createElement(
                "p",
                null,
                "T\xE4m\xE4 tietosuojaseloste antaa sinulle sovellettavan tietosuojalains\xE4\xE4d\xE4nn\xF6n edellytt\xE4m\xE4t tiedon henkil\xF6tietojen k\xE4sittelyst\xE4."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "1) Rekisterinpit\xE4j\xE4"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Nimi: Maap\xF6rssi Oy",
                _react2.default.createElement("br", null),
                "Y-tunnus: 2335445-0",
                _react2.default.createElement("br", null),
                "Postiosoite: Linnoitustie 6, 02600 Espoo, Suomi"
              ),
              _react2.default.createElement(
                "h4",
                null,
                "2) Rekisteriasioista vastaava henkil\xF6"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Nimi: Eeva Vahtera",
                _react2.default.createElement("br", null),
                "Postiosoite: c/o Maap\xF6rssi Oy, Linnoitustie 6, 02600 Espoo. puhelinnumero: 0407698197;",
                _react2.default.createElement("br", null),
                "S\xE4hk\xF6postiosoite: info@maaporssi.fi."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "3) Henkil\xF6tietojen k\xE4sittelyn tarkoitus ja oikeusperuste"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Henkil\xF6tietoja voidaan k\xE4sitell\xE4 seuraavia tarkoituksia varten:",
                _react2.default.createElement("br", null),
                "Sivuston ja Kuljetusapplikaation K\xE4ytt\xE4jien k\xE4ytt\xF6kokemuksen hoitaminen ja kehitt\xE4minen;",
                _react2.default.createElement("br", null),
                "Sivuston ja Kuljetusapplikaation Palvelun hoitaminen ja kehitt\xE4minen;",
                _react2.default.createElement("br", null),
                "Sivuston ja Kuljetusapplikaation laadun yleinen parantaminen;",
                _react2.default.createElement("br", null),
                "Viestiminen Maap\xF6rssin ja Palvelun K\xE4ytt\xE4jien v\xE4lill\xE4;",
                _react2.default.createElement("br", null),
                "Kolmannen Tahon Tarjoamien Palveluiden hy\xF6dynt\xE4minen;",
                _react2.default.createElement("br", null),
                "Palvelun k\xE4ytt\xF6\xF6n liittyvien tarjousten v\xE4litt\xE4minen;",
                _react2.default.createElement("br", null),
                "Markkinointi;",
                _react2.default.createElement("br", null),
                "Analysointi ja tilastointi;",
                _react2.default.createElement("br", null),
                "Rekisterinpit\xE4j\xE4n lakis\xE4\xE4teisten velvoitteiden t\xE4ytt\xE4minen;",
                _react2.default.createElement("br", null),
                "Mielipide- ja markkinatutkimukset; sek\xE4",
                _react2.default.createElement("br", null),
                "Muut vastaavat k\xE4ytt\xF6tarkoitukset."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekisterinpit\xE4j\xE4 ei k\xE4yt\xE4 automaattista p\xE4\xE4t\xF6ksentekoa, kuten automaattista profilointia, osana henkil\xF6tietojen k\xE4sittelytoimintaa."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Henkil\xF6tietojen k\xE4sittely perustuu tietosuojalains\xE4\xE4d\xE4nn\xF6n mukaiseen oikeusperusteeseen. K\xE4sittelyn oikeusperusteita voivat olla K\xE4ytt\xE4j\xE4n antama suostumus, rekisterinpit\xE4j\xE4n ja K\xE4ytt\xE4j\xE4n v\xE4linen sopimussuhde, rekisterinpit\xE4j\xE4n lakis\xE4\xE4teinen velvoite tai rekisterinpit\xE4j\xE4n oikeutettu etu."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Milloin henkil\xF6tietojen k\xE4sittely perustuu K\xE4ytt\xE4j\xE4n antamaan suostumukseen, K\xE4ytt\xE4j\xE4 voi peruuttaa antamansa suostumuksen milloin tahansa. T\xE4ll\xE4 voi olla vaikutusta Sivuston, Kuljetusapplikaation tai Palveluiden k\xE4ytt\xE4miseen. Suostumuksen peruutus ei kuitenkaan vaikuta k\xE4sittelyperusteen laillisuuteen suostumuksen perumista edelt\xE4v\xE4ll\xE4 ajalla."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "4) Rekisterin tietosis\xE4lt\xF6"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekisteri voi sis\xE4lt\xE4\xE4 seuraavia K\xE4ytt\xE4j\xE4\xE4n liittyvi\xE4 tietoja:",
                _react2.default.createElement("br", null),
                "Yhteystiedot (esim. nimi, osoite, puhelinnumerot ja s\xE4hk\xF6postiosoitteet);",
                _react2.default.createElement("br", null),
                "Ik\xE4, sukupuoli, arvo tai ammatti ja \xE4idinkieli;",
                _react2.default.createElement("br", null),
                "Mahdolliset rekister\xF6itymistiedot (esim. k\xE4ytt\xE4j\xE4tunnus, salasana ja muut mahdolliset yksil\xF6iv\xE4t tunnukset), mutta eritoten:",
                _react2.default.createElement("br", null),
                "Perusprofiilissa K\xE4ytt\xE4j\xE4n rekisteriin tallentamat yhteystiedot, k\xE4ytt\xE4j\xE4tunnus ja salasana;",
                _react2.default.createElement("br", null),
                "Kuljettajaprofiilissa K\xE4ytt\xE4j\xE4n rekisteriin tallentamat yhteystiedot, k\xE4ytt\xE4j\xE4tunnus ja salasana;",
                _react2.default.createElement("br", null),
                "Yksityisprofiilissa K\xE4ytt\xE4j\xE4n rekisteriin tallentamat yhteystiedot, k\xE4ytt\xE4j\xE4tunnus ja salasana; ja",
                _react2.default.createElement("br", null),
                "Ammattiprofiilissa K\xE4ytt\xE4j\xE4n rekisteriin tallentamat y-tunnus, yrityksen osoite, yhteystiedot, k\xE4ytt\xE4j\xE4tunnus ja salasana;",
                _react2.default.createElement("br", null),
                "K\xE4ytt\xE4j\xE4n mahdollisesti antamat profilointi- ja kiinnostustiedot;",
                _react2.default.createElement("br", null),
                "Mahdollista asiakassuhdetta koskevat tiedot (esim. laskutus- ja maksutiedot, tuote-, palvelu- ja tilaustiedot, asiakaspalautteet ja yhteydenotot, arvonta- ja kilpailuvastaustiedot sek\xE4 peruutustiedot);",
                _react2.default.createElement("br", null),
                "Viestinn\xE4n toteuttamiseen liittyv\xE4t tiedot sek\xE4 palveluiden ja Sivuston ja Kuljetusapplikaation k\xE4ytt\xF6\xE4 koskevat tiedot (esim. selailu- ja hakutiedot);",
                _react2.default.createElement("br", null),
                "Kuljetusapplikaatiolla luotujen digitaalisten siirtoasiakirjojen kautta ker\xE4tyt tiedot l\xE4hett\xE4v\xE4st\xE4, vastaanottavasta ja kuljettavasta osapuolesta (esim. yhteystiedot ja y-tunnus);",
                _react2.default.createElement("br", null),
                "K\xE4ytt\xE4j\xE4n j\xE4tt\xE4mien ilmoituksien sis\xE4lt\xF6\xF6n ja ajankohtaan liittyv\xE4t tiedot; sek\xE4 Muut mahdolliset K\xE4ytt\xE4j\xE4n suostumuksella ker\xE4tyt tiedot."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekisteri voi lis\xE4ksi sis\xE4lt\xE4\xE4 seuraavia Palvelun k\xE4yt\xF6st\xE4 havainnoituja muita tietoja:",
                _react2.default.createElement("br", null),
                "Tarjoaja- ja vastaanottajailmoitusten kokonaislukum\xE4\xE4r\xE4;",
                _react2.default.createElement("br", null),
                "Tarjoaja- ja vastaanottajailmoitusten lukum\xE4\xE4r\xE4 ilmoituksessa mainitun materiaalityypin mukaan;",
                _react2.default.createElement("br", null),
                "Tarjoaja- ja vastaanottajailmoituksissa ilmoitetut m\xE4\xE4r\xE4t materiaalityypin mukaan;",
                _react2.default.createElement("br", null),
                "Kuljetussovelluksella luotujen digitaalisten siirtoasiakirjojen lukum\xE4\xE4r\xE4;",
                _react2.default.createElement("br", null),
                "Kuljetussovelluksella luotujen digitaalisten siirtoasiakirjojen kautta ker\xE4tyt tiedot kuljetetusta materiaalista (esim. sen kokonaism\xE4\xE4r\xE4, m\xE4\xE4r\xE4 materiaalityypin mukaan ja kuljetusten lukum\xE4\xE4r\xE4 kuljetetun materiaalityypin mukaan); ja",
                _react2.default.createElement("br", null),
                "Kuljetussovelluksen ker\xE4\xE4m\xE4 tieto kuljetusta reitist\xE4, kuljetun reitin pituudesta, kuljetusmatkan ajallisesta kestosta sek\xE4 muusta kuljetusprosessiin liittyv\xE4st\xE4 ajallisesta kestosta (esim. odotusajat l\xE4hett\xE4v\xE4ss\xE4 ja vastaaanottavassa osoitteessa)."
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4sitelt\xE4v\xE4t henkil\xF6tiedot ovat tarpeellisia, jotta K\xE4ytt\xE4j\xE4 voi k\xE4ytt\xE4\xE4 Sivustoa, Kuljetusapplikaatiota ja Palveluita. Rekisterinpit\xE4j\xE4 k\xE4sittelee henkil\xF6tietoja Sivuston, Kuljetusapplikaation ja Palveluiden tarjoamiseksi."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "5) S\xE4\xE4nn\xF6nmukaiset tietol\xE4hteet"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekister\xF6idyt tiedot saadaan s\xE4\xE4nn\xF6nmukaisesti:",
                _react2.default.createElement("br", null),
                "K\xE4ytt\xE4j\xE4lt\xE4 itselt\xE4\xE4n rekister\xF6itymisen yhteydess\xE4, puhelimitse, internetin kautta, s\xE4hk\xF6postilla tai muulla vastaavalla tavalla;",
                _react2.default.createElement("br", null),
                "Ev\xE4steiden tai muiden vastaavien tekniikoiden avulla; ja",
                _react2.default.createElement("br", null),
                "VRK/V\xE4est\xF6tietoj\xE4rjestelm\xE4st\xE4, Postin osoitetietoj\xE4rjestelm\xE4st\xE4, puhelinyhti\xF6iden yhteystietorekistereist\xE4 ja muista vastaavista yksityisist\xE4 ja julkisista rekistereist\xE4."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "6) S\xE4\xE4nn\xF6nmukaiset tietojen luovutukset ja tietojen siirto EU:n tai Euroopan talousalueen ulkopuolelle"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekisterinpit\xE4j\xE4 k\xE4sittelee henkil\xF6tietoja luottamuksellisesti, ja niihin on p\xE4\xE4sy ainoastaan henkil\xF6ill\xE4, joilla on ty\xF6n puolesta tarve k\xE4ytt\xE4\xE4 henkil\xF6tietorekisteri\xE4. Rekisterinpit\xE4j\xE4 ei p\xE4\xE4s\xE4\xE4nt\xF6isesti luovuta henkil\xF6tietoja ulkopuolisille. Tietoja voidaan luovuttaa rekister\xF6idyn suostumuksella suoramarkkinointitarkoituksiin sovellettavan lains\xE4\xE4d\xE4nn\xF6n mukaisesti."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekisterinpit\xE4j\xE4 k\xE4ytt\xE4\xE4 Sivuston, Kuljetusapplikaation ja Palveluiden tarjoamisen yhteydess\xE4 luotettavia palveluntarjoajia, jotka k\xE4sittelev\xE4t henkil\xF6tietoja rekisterinpit\xE4j\xE4n puolesta n\xE4iden tarjoamisen mahdollistamiseksi."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Tietoja voidaan sovellettavan tietosuojalains\xE4\xE4d\xE4nn\xF6n sallimissa rajoissa siirt\xE4\xE4 EU:n tai Euroopan talousalueen ulkopuolella sijaitsevalle palvelimella tallennettavaksi ja k\xE4sitelt\xE4v\xE4ksi rekisterinpit\xE4j\xE4n lukuun."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "7) Tietojen s\xE4ilytys"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekisterinpit\xE4j\xE4 k\xE4sittelee ja s\xE4ilytt\xE4\xE4 henkil\xF6tietoja ainoastaan niin kauan kuin on tarpeellista henkil\xF6tiedon ennalta m\xE4\xE4ritellyn k\xE4ytt\xF6tarkoituksen kannalta. Tarpeettomiksi muuttuneet henkil\xF6tiedot, joita rekisterinpit\xE4j\xE4ll\xE4 ei ole en\xE4\xE4 perustetta tai lainmukaista velvollisuutta s\xE4ilytt\xE4\xE4 eik\xE4 k\xE4sitell\xE4, poistetaan s\xE4\xE4nn\xF6llisin v\xE4liajoin rekisterinpit\xE4j\xE4n omien tietosuojak\xE4yt\xE4nt\xF6jen mukaisesti."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "8) Rekister\xF6idyn oikeudet"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekister\xF6idyll\xE4 on EU:n yleisen tietosuoja-asetuksen mukaisesti oikeus:"
              ),
              _react2.default.createElement(
                "ul",
                null,
                _react2.default.createElement(
                  "li",
                  null,
                  "saada tietoa henkil\xF6tietojen k\xE4sittelyst\xE4"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "saada p\xE4\xE4sy tietoihin"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "oikaista tietoja"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "poistaa tiedot ja tulla unohdetuksi"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "rajoittaa tietojen k\xE4sittely\xE4"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "siirt\xE4\xE4 tiedot j\xE4rjestelm\xE4st\xE4 toiseen"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "vastustaa tietojenk\xE4sittely\xE4"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "olla joutumatta automaattisen p\xE4\xE4t\xF6ksenteon kohteeksi"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "tehd\xE4 valitus tietosuojaviranomaiselle, joka Suomessa on Tietosuojavaltuutetun toimisto,",
                  " ",
                  _react2.default.createElement(
                    "a",
                    { href: "http://www.tietosuoja.fi" },
                    "www.tietosuoja.fi"
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekisterinpit\xE4j\xE4 vastaa pyynt\xF6ihisi p\xE4\xE4asiassa kuukauden sis\xE4ll\xE4 yhteydenotostasi. Voit k\xE4ytt\xE4\xE4 oikeuksiasi ottamalla yhteytt\xE4 rekisteriasioista vastaavaan henkil\xF6\xF6n. Rekisterinpit\xE4j\xE4ll\xE4 on oikeus ja velvollisuus varmentua henkil\xF6llisyydest\xE4si, josta johtuen rekisterinpit\xE4j\xE4n on kyett\xE4v\xE4 tunnistamaan sinut riitt\xE4v\xE4ll\xE4 tavalla ennen pyynt\xF6si toteuttamista."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "9) Rekisterin suojauksen periaatteet"
              ),
              _react2.default.createElement(
                "p",
                null,
                "K\xE4ytt\xE4j\xE4tietoja sis\xE4lt\xE4v\xE4n j\xE4rjestelm\xE4n k\xE4ytt\xF6\xF6n ovat oikeutettuja vain ne ty\xF6ntekij\xE4t, joilla ty\xF6ns\xE4 puolesta on oikeus k\xE4sitell\xE4 k\xE4ytt\xE4j\xE4tietoja. Kullakin oikeutetulla ty\xF6ntekij\xE4ll\xE4 on oma k\xE4ytt\xE4j\xE4tunnus ja salasana j\xE4rjestelm\xE4\xE4n."
              ),
              _react2.default.createElement(
                "p",
                null,
                "Tiedot ker\xE4t\xE4\xE4n tietokantoihin, jotka ovat palomuurein, salasanoin ja muilla teknisill\xE4 keinoilla suojattuja. Tietokannat ja niiden varmuuskopiot sijaitsevat lukituissa tiloissa ja tietoihin p\xE4\xE4sev\xE4t k\xE4siksi vain ne ty\xF6ntekij\xE4t, joilla ty\xF6ns\xE4 puolesta on oikeus k\xE4sitell\xE4 k\xE4ytt\xE4j\xE4tietoja."
              ),
              _react2.default.createElement(
                "h4",
                null,
                "10) Lopuksi"
              ),
              _react2.default.createElement(
                "p",
                null,
                "Rekisterinpit\xE4j\xE4 varaa oikeuden muuttaa t\xE4t\xE4 rekisteriselostetta. Rekisterinpit\xE4j\xE4 ilmoittaa rekisteriselosteen muutoksista. Suosittelemme tarkastamaan s\xE4\xE4nn\xF6llisin v\xE4liajoin, miten k\xE4sittelemme henkil\xF6tietoja."
              ),
              _react2.default.createElement(
                "p",
                null,
                "T\xE4m\xE4 rekisteriseloste on viimeksi p\xE4ivitetty 4.2.2022."
              )
            )
          )
        )
      );
    }
  }]);
  return TermsOfService;
}(_react.Component);

exports.default = TermsOfService;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/TermsOfService/TermsOfService.js
 ** module id = 1245
 ** module chunks = 0
 **/